import { makeStyles } from "@mui/styles";

const useStyle = makeStyles((theme) => ({
  card: {
    borderWidth: "1px !important",
    borderRadius: "10px !important",
    maxWidth: "32rem",
  },

  qrCode: {
    background: "#fff",
    height: theme.spacing(20),
    marginTop: 10,
  },
  listaInformacoes: {
    listStyle: "none",
  
  },

  itemList: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    maxWidth: "100vw",
    [theme.breakpoints.up("sm")]: {
      justifyContent: "space-between",
      alignItems: "center",
    },
  },
  iconButton: {
    height: 22,
  },
}));

export default useStyle;
